import { DeepWriteable } from 'ia-react-core/~/interfaces/DeepWriteable';
import compose from '../../../utils/components/_compose';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import withValidators from '../../../hocs/form/_withValidators';
import connectScoped from '../../../hocs/redux/_connectScoped';
import withScope from '../../../hocs/redux/withScope';
import withTransclusion from '../../../hocs/transclusion/withTransclusion';
import withControlFormContext from './withControlFormContext';
import withControlGroupContext from '../../../hocs/form/_withControlGroupContext';
import withUnionControlGroupContext from '../../../hocs/form/_withUnionControlGroupContext';

import Control, { ControlComposedProps, ControlProps } from './Control';

const ComposedControl: (<
Value,
StateValue = Value,
E extends Element= Element,
V extends Record<string, unknown> = {},
>(
props: ControlProps<Value, StateValue, E> & (keyof V extends never ? {} : V)
) => React.ReactElement<ControlProps<Value, StateValue, E> & (keyof V extends never ? {} : V)>) & {
  displayName: typeof Control.displayName;
  publicProps: typeof Control.publicProps;
} = compose<any>(
  withTransclusion,
  withUniqueId('controlId'),
  withValidators,
  withControlFormContext,
  withControlGroupContext,
  withUnionControlGroupContext,
  withScope,
  connectScoped<DeepWriteable<ControlComposedProps<string, string>>, [string, string, string, string[], string, string[]]>(
    (name, formReducerKey, ancestorValuesDst, formScope, ancestorFormReducerKey) => ({
      value: [ancestorValuesDst, ...formScope.slice(1), name].join('.'),
      errors: [formReducerKey, 'errors', name].join('.'),
      warnings: [formReducerKey, 'warnings', name].join('.'),
      cautions: [formReducerKey, 'cautions', name].join('.'),
      clientErrors: [ancestorFormReducerKey, 'clientErrors.controlErrors', ...formScope.slice(1), name].join('.'),
      clientWarnings: [ancestorFormReducerKey, 'clientErrors.controlWarnings', ...formScope.slice(1), name].join('.'),
      clientCautions: [ancestorFormReducerKey, 'clientErrors.controlCautions', ...formScope.slice(1), name].join('.'),
      isTouched: [formReducerKey, 'touched', name].join('.'),
      isDirty: [formReducerKey, 'dirty', name].join('.'),
      isInitialized: [formReducerKey, 'isInitialized'].join('.'),
      isSubmitted: [formReducerKey, 'isSubmitted'].join('.'),
    }),
    ({ name, formReducerKey, ancestorValuesDst, formScope, ancestorFormReducerScope, ancestorFormReducerKey }) => [name, formReducerKey, ancestorValuesDst, formScope, ancestorFormReducerKey, ancestorFormReducerScope],
    (name, formReducerKey, ancestorValuesDst, formScope, ancestorFormReducerKey, ancestorFormReducerScope) => ({ scope: ancestorFormReducerScope }),
  ),
)(Control);

ComposedControl.displayName = Control.displayName;

export * from './Control';
export default ComposedControl;
